import { render, staticRenderFns } from "./general.html?vue&type=template&id=5059d0cc&scoped=true&external"
import script from "./general.vue?vue&type=script&lang=js"
export * from "./general.vue?vue&type=script&lang=js"
import style0 from "./general.css?vue&type=style&index=0&id=5059d0cc&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5059d0cc",
  null
  
)

export default component.exports